import ForumCardDetail from './ForumCardDetail';

export default ForumCardDetail;
